import React from 'react'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import PropTypes from 'prop-types'
import config from '../../../config'

import CheckoutForm from './CheckoutForm'

const stripePromise = loadStripe(config.REACT_APP_STRIPE_PB)

export default function PaymentForm({
  clientSecret,
  redirectUri,
  closeModalPayment,
}) {
  const appearance = {
    theme: 'stripe',
  }
  const options = {
    clientSecret,
    appearance,
  }

  return (
    <>
      {clientSecret ? (
        <div className="payment_content">
          <Elements options={options} stripe={stripePromise}>
            <CheckoutForm
              clientSecret={clientSecret}
              redirectUri={redirectUri}
              closeModalPayment={closeModalPayment}
            />
          </Elements>
        </div>
      ) : (
        <p>loading</p>
      )}
    </>
  )
}

PaymentForm.propTypes = {
  clientSecret: PropTypes.string,
  redirectUri: PropTypes.string,
  closeModalPayment: PropTypes.func,
}
